export default __webpack_public_path__ + "static/Raw_Meat-3b970959446be520340983bc4e92d16b.png";